import { useEffect, useMemo, useState } from 'react';
import ServicesMenuControlGeral from '../../utils/ServicesMenuControlGeral';
import api from '../../services/api';

const PROVINCIAS_FALLBACK = [
  { name: 'Luanda',         icon: '/icones/mapaProvinciasAngola/Luanda.svg' },
  { name: 'Bengo',          icon: '/icones/mapaProvinciasAngola/Bengo.svg' },
  { name: 'Benguela',       icon: '/icones/mapaProvinciasAngola/Benguela.svg' },
  { name: 'Bie',            icon: '/icones/mapaProvinciasAngola/Bie.svg' },
  { name: 'Cabinda',        icon: '/icones/mapaProvinciasAngola/Cabinda.svg' },
  { name: 'Cuando-cubango', icon: '/icones/mapaProvinciasAngola/Cuando-cubango.svg' },
  { name: 'Cuanza-norte',   icon: '/icones/mapaProvinciasAngola/Cuanza-norte.svg' },
  { name: 'Cuanza-sul',     icon: '/icones/mapaProvinciasAngola/Cuanza-sul.svg' },
  { name: 'Cunene',         icon: '/icones/mapaProvinciasAngola/Cunene.svg' },
  { name: 'Huambo',         icon: '/icones/mapaProvinciasAngola/Huambo.svg' },
  { name: 'Huila',          icon: '/icones/mapaProvinciasAngola/Huila.svg' },
  { name: 'Lunda-norte',    icon: '/icones/mapaProvinciasAngola/Lunda-norte.svg' },
  { name: 'Lunda-sul',      icon: '/icones/mapaProvinciasAngola/Lunda-sul.svg' },
  { name: 'Malange',        icon: '/icones/mapaProvinciasAngola/Malange.svg' },
  { name: 'Moxico',         icon: '/icones/mapaProvinciasAngola/Moxico.svg' },
  { name: 'Namibe',         icon: '/icones/mapaProvinciasAngola/Namibe.svg' },
  { name: 'Uige',           icon: '/icones/mapaProvinciasAngola/Uige.svg' },
  { name: 'Zaire',          icon: '/icones/mapaProvinciasAngola/Zaire.svg' },
];

const ICON_BY_KEY = {
  luanda: '/icones/mapaProvinciasAngola/Luanda.svg',
  bengo: '/icones/mapaProvinciasAngola/Bengo.svg',
  benguela: '/icones/mapaProvinciasAngola/Benguela.svg',
  bie: '/icones/mapaProvinciasAngola/Bie.svg',
  cabinda: '/icones/mapaProvinciasAngola/Cabinda.svg',
  'cuando-cubango': '/icones/mapaProvinciasAngola/Cuando-cubango.svg',
  'cuanza-norte': '/icones/mapaProvinciasAngola/Cuanza-norte.svg',
  'cuanza-sul': '/icones/mapaProvinciasAngola/Cuanza-sul.svg',
  cunene: '/icones/mapaProvinciasAngola/Cunene.svg',
  huambo: '/icones/mapaProvinciasAngola/Huambo.svg',
  huila: '/icones/mapaProvinciasAngola/Huila.svg',
  'lunda-norte': '/icones/mapaProvinciasAngola/Lunda-norte.svg',
  'lunda-sul': '/icones/mapaProvinciasAngola/Lunda-sul.svg',
  malange: '/icones/mapaProvinciasAngola/Malange.svg',
  moxico: '/icones/mapaProvinciasAngola/Moxico.svg',
  namibe: '/icones/mapaProvinciasAngola/Namibe.svg',
  uige: '/icones/mapaProvinciasAngola/Uige.svg',
  zaire: '/icones/mapaProvinciasAngola/Zaire.svg',
};

function normalizeProvinciaName(name = '') {
  return name
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .trim()
    .toLowerCase()
    .replace(/kwanza/g, 'cuanza')
    .replace(/kuando/g, 'cuando')
    .replace(/\s+/g, '-')
    .replace(/-+/g, '-');
}

export default function MenuControlGeral() {
  const [provinciasApi, setProvinciasApi] = useState([]);

  useEffect(() => {
    api.get('/provincias')
      .then((res) => {
        const provincias = Array.isArray(res?.data?.provincias) ? res.data.provincias : [];
        setProvinciasApi(provincias);
      })
      .catch(() => {
        setProvinciasApi([]);
      });
  }, []);

  const provincias = useMemo(() => {
    if (provinciasApi.length === 0) return PROVINCIAS_FALLBACK;

    return provinciasApi
      .map((p) => {
        const name = p?.designacao || p?.nome || p?.name || '';
        const key = normalizeProvinciaName(name);

        return {
          name,
          icon: ICON_BY_KEY[key] || '/icones/mapaProvinciasAngola/Luanda.svg',
        };
      })
      .filter((p) => p.name)
      .sort((a, b) => a.name.localeCompare(b.name, 'pt'));
  }, [provinciasApi]);

  return (
    <div className="tw-w-full">

      {/* Cabeçalho */}
      <div className="tw-flex tw-items-center tw-gap-3 tw-px-5 tw-py-4 tw-bg-gradient-to-r tw-from-[#85287e]/10 tw-to-transparent tw-border-b tw-border-[#85287e]/20 tw-mb-1">
        <div className="tw-w-1.5 tw-h-7 tw-bg-[#85287e] tw-rounded-full tw-flex-shrink-0" />
        <h2 className="tw-text-[14px] tw-font-extrabold tw-tracking-widest tw-text-[#85287e] tw-uppercase tw-leading-none">
          Estabelecimentos por Província
        </h2>
        <span className="tw-ml-auto tw-text-xs tw-text-gray-400 tw-font-medium">
          {provincias.length} províncias
        </span>
      </div>

      {/* Grid de províncias */}
      <div className="tw-flex tw-flex-wrap  tw-gap-4  tw-py-3">
        {provincias.map(({ name, icon }) => (
          <ServicesMenuControlGeral
            key={name}
            provincia={name}
            icone={icon}
          />
        ))}
      </div>
    </div>
  );
}
